import { createStructuredSelector } from 'reselect';
import {
  selectCsrBusinessFunction,
  selectApplicableBusinessFunction,
} from '../../../../../selectors/globalSelectors';
import {
  fetchRAGState,
  selectSelectedCharityName,
  selectStartDate,
  selectNoOfPayments,
  selectGrantAmount,
} from './RecommendGrantPageSelectors';
import { selectFrequency } from './ConfirmationPageSelectors';
import { selectScheduleId } from './EditGrantSelectors';
import { selectCancel, selectCancelAll } from './ViewGrantDetailSelectors';

const selectSpawns = (state) => {
  const { spawns } = fetchRAGState(state);
  return spawns;
};

const selectUpdateSpawn = (state) => {
  const { updateSpawn } = fetchRAGState(state);
  return updateSpawn;
};

export const customizeSpawnDerivedStates = createStructuredSelector({
  grantName: selectSelectedCharityName,
  startDate: selectStartDate,
  frequency: selectFrequency,
  noOfPayment: selectNoOfPayments,
  grantAmount: selectGrantAmount,
  spawns: selectSpawns,
  scheduleId: selectScheduleId,
  cancelSingleStatus: selectCancel,
  cancelAllStatus: selectCancelAll,
  updateSpawn: selectUpdateSpawn,
  csrBusinessFunction: selectCsrBusinessFunction,
  applicable_business_function: selectApplicableBusinessFunction,
});
